module.exports = __webpack_public_path__ + "static/media/formHeader.dffe8a31.png";